import { Box, Typography } from '@mui/material';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';


function Footer() {
    const footerStyle = {
        backgroundColor: '#fce5cc',
        textAlign: 'center',
        height: '250px',
        padding: '10px',
        borderTop: '1px solid #ccc',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center'
    }

    const textStyle = {
        fontWeight: '400',
        fontFamily: 'sans-serif',
        fontSize: 15,
        textAlign: 'left'
    }

    return (
        <Box sx={footerStyle}>
            <Box marginTop={"4%"} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center' }}>
                <Typography marginRight={"5%"} sx={textStyle} variant="h1">Contact: </Typography>
                <Box className="ContactTextBox" marginBottom="5%" sx={{display: 'flex', flexDirection: 'column', justifyContent: 'left', alignItems: 'left' }}>
                    <Box className="TelephoneTextBox" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', alignContent: 'left' }}>
                        <PhoneRoundedIcon fontSize="small"></PhoneRoundedIcon>
                        <Typography sx={textStyle} marginBottom={"20px"} marginLeft={"10px"} variant="h1">
                            <a href="tel:+923000200950">+92 300 0200950</a>
                        </Typography>
                    </Box>

                    <Box className="EmailTextBox" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', alignContent: 'left' }}>
                        <EmailRoundedIcon fontSize="small"></EmailRoundedIcon>
                        <Typography sx={textStyle} marginLeft={"10px"} variant="h1">
                            <a href="mailto:info@styalica.com">info@styalica.com</a>
                        </Typography>
                    </Box>

                </Box>
            </Box>
            <p>© Copyright 2015 by Styalica. All Rights Reserved.</p>
        </Box>
    );
}

export default Footer;